
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from "@angular/material/icon";
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-display-filter-field',
    imports: [NgIf, TranslateDirective, TranslatePipe, MatIconModule],
    templateUrl: './display-filter-field.component.html',
    styleUrls: ['./display-filter-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayFilterFieldComponent {
  @Input() isFilterField: boolean = false;
  #questionnaireStore = inject(QuestionnaireStore);
  isUnauthorized$ = toSignal(this.#questionnaireStore.isUnauthorized$);
}
